import React, { useEffect, useState, useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from "gatsby-image";
import { withTranslation } from 'react-i18next';
import GoogleMapReact from 'google-map-react';

import Employee from './component.employee';
import Geocode from "react-geocode";
import ThemeContext from "../../context/context.theme";
import BackgroundImage from 'gatsby-background-image';

import { calculateDistance } from "../../utilties/helpers";

const HeroDistributor = ({ distributor, t, language, dealers, setDealers, loadLocation, setLoadLocation, extendedDisplay = false, showDealerHeader = true }) => {
  
    const [location, setLocation] = useState('');
    const theme = useContext(ThemeContext);
    const [latLong, setLatLong] = useState({
        isAvailable: false,
        lat: '',
        long: '',
    });

    const [saleTab, setSaleTab] = useState(false);
    const [infoTab, setInfoTab] = useState(false);
    const [changeLocation, setChangeLocation] = useState(false);
    const { title, ACFDealerBlockFields: details } = distributor;
    // use the dealer location if it exists (so the Polish dealer is based in Germany, we want the main lat long to be poland, but this map should show the German dealer location:)
    const googleMapProps = {
        center: {
          lat: details.dealerLocation ? details.dealerLocation.latitude : details.location.latitude,
          lng: details.dealerLocation ? details.dealerLocation.longitude : details.location.longitude,
        },
        zoom: 11
    };
    
    let pageLanguage = 'EN';
    if(typeof language !== "undefined") {
        pageLanguage = language.code;
    }
    pageLanguage = pageLanguage.toLowerCase();
    let pageRegion = pageLanguage;
    if(pageRegion == 'zh') {
        pageRegion = 'cn';
    }

const exampleMapStyles = [
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#150d0a",
            },
        ],
    },
    {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [
            {
                color: "#150d0a",
            },
        ],
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#f7f7f7",
            },
        ],
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#f7f7f7",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "labels",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5",
            },
        ],
    },
];

    async function requestLocation() {
        const browserLocation = window.navigator && window.navigator.geolocation;

        if (browserLocation) {
            browserLocation.getCurrentPosition(async (position) => {
                await setLatLong({
                    isAvailable: true,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                });
                setLocation('Your present location');
                theme.setNotification({ message: t("distributor.find-deal.order-message"), timestamp: Date(), success: true });

                // save this to local storage:
                Geocode.setApiKey(process.env.GATSBY_GOOGLE_API_KEY);
                let languageKey = "en";
                if(typeof language !== "undefined") {
                    languageKey = language.code.toLowerCase();
                }
                Geocode.setLanguage(languageKey);
                Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(response => {
                    // parse the results to find the country name:
                    for (let i = 0; i < response.results[0].address_components.length; i++) {
                      for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
                        if(response.results[0].address_components[i].types[j] == "country") {
                            localStorage.setItem('storedCountry',response.results[0].address_components[i].long_name);
                        }
                      }
                    }
                }).catch((error) => {
                });
            }, (error) => {
                theme.setNotification({ message: t("distributor.find-deal.location-message"), timestamp: Date() });
            });
        }
    }

    function orderDistributors() {
        const newDealers = [];
        dealers.map(dealer => {
            if(dealer.ACFDealerBlockFields.location !== null){
                dealer.distance = calculateDistance({
                    lat1: latLong.lat,
                    lon1: latLong.long,
                    lat2: dealer.ACFDealerBlockFields.location.latitude,
                    lon2: dealer.ACFDealerBlockFields.location.longitude,
                });
                newDealers.push(dealer);
            }
        })

        newDealers.sort((dealerA, dealerB) => (dealerA.distance > dealerB.distance) ? 1 : -1);

        setDealers(newDealers);
    }

    const handleInputChange = event => {
        setLocation(event.target.value);
    };

    async function findLocation(event) {
        if(event) {
            event.preventDefault();
        }

        // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
        Geocode.setApiKey(process.env.GATSBY_GOOGLE_API_KEY);

        let languageKey = "en";
        if(typeof language !== "undefined") {
            languageKey = language.code.toLowerCase();
        }
        Geocode.setLanguage(languageKey);

        // Get latidude & longitude from address.
        Geocode.fromAddress(location).then(response => {
            const { lat, lng } = response.results[0].geometry.location;
            setLatLong({
                lat: lat,
                long: lng
            });
            if(event) {
                theme.setNotification({ message: t("distributor.find-deal.order-message"), timestamp: Date(), success: true });
            }
        }).catch((error) => {
            if(event) {
                theme.setNotification({ message: t("distributor.find-deal.not-found-message"), timestamp: Date() });
            }
        });
    }

    useEffect(() => {
        orderDistributors();
    }, [latLong]);

    useEffect(() => {
        findLocation();
    }, [location]);

    useEffect(() => {
        if(loadLocation.length>0) {
            // not empty or array or empty string
            setLocation(loadLocation);     
        }
    }, [loadLocation]);


const AnyReactComponent = () => <div className="c-distributor__map-pin"></div>;

    return (
        <div>
            {showDealerHeader &&
                <>
                    {details.country &&
                        <div className="container">
                            <h1 className="c-distributor__country">{t("distributor.distributor.local-dealer")} - {details.dealerCountry ? details.dealerCountry : details.country}</h1>
                            <button className={changeLocation ? "c-distributor__change-location c-distributor__change-location--active" : "c-distributor__change-location"} onClick={() => setChangeLocation(!changeLocation)}>{t("distributor.find-deal.change-location")}</button>
                        </div>
                    }

                    {changeLocation &&
                        <div className="container">
                            <div className="c-distributor__location-form">
                                <form className="c-hero-input__search" onSubmit={handleInputChange}>
                                    <input className="c-hero-input__search-input" placeholder={t("distributor.find-deal.input-placeholder")} value={location} onChange={handleInputChange} />
                                    <button className="c-hero-input__search-button" aria-label={t("distributor.find-deal.button-label")} onClick={(event) => findLocation(event)}>
                                        <i className="c-hero-input__search-icon far fa-search"></i>
                                    </button>
                                </form>

                                <button className="c-hero-input__additional" onClick={() => requestLocation()}>
                                    <i className="c-hero-input__additional-icon fas fa-location-arrow"></i>
                                    <span className="c-hero-input__additional-desc">{t("distributor.find-deal.button-description")}</span>
                                </button>
                            </div>
                        </div>
                    }
                </>
            }

            {extendedDisplay &&
                <div className="container">
                    <article>
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className="c-distributor">
                                    <div className="c-distributor__content">
                                        <header className="c-distributor__header">
                                            
                                            {details.language &&
                                                <span className="c-distributor__language">{details.language}</span>
                                            }
                                            {title &&
                                                <h2 className="c-distributor__title" dangerouslySetInnerHTML={{ __html: title }}></h2>
                                            }
                                        </header>
                                        
                                        {details.address &&
                                            <div className="c-distributor__address">
                                                <span className="c-distributor__address-details" dangerouslySetInnerHTML={{ __html: details.address }}></span>
                                            </div>
                                        }
                                        {(details.email || details.website || details.phone) &&
                                            <div className="c-distributor__contact">
                                                <ul className="c-distributor__contact-list">
                                                    {details.email &&
                                                        <li className="c-distributor__contact-item c-distributor__contact-item__email">
                                                            <a href={`mailto:${details.publicEmail ? details.publicEmail : details.email}`}>{details.publicEmail ? details.publicEmail : details.email}</a>
                                                        </li>
                                                    }
                                                    {details.website &&
                                                        <li className="c-distributor__contact-item c-distributor__contact-item__site">
                                                            <a href={details.website}>{details.website}</a>
                                                        </li>
                                                    }
                                                    {details.phone &&
                                                        <li className="c-distributor__contact-item c-distributor__contact-item__phone">
                                                            <a href={`tel:${details.phone}`} dangerouslySetInnerHTML={{ __html: details.phone}}></a>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-8 col-md-6 c-distributor__map">
                                <GoogleMapReact
                                    bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY, language: pageLanguage, region: pageLanguage }}
                                    defaultCenter={googleMapProps.center}
                                    center={googleMapProps.center}
                                    options={{
                                        styles: exampleMapStyles,
                                    }}
                                    defaultZoom={googleMapProps.zoom}
                                >
                                    <AnyReactComponent
                                        lat={googleMapProps.center.lat}
                                        lng={googleMapProps.center.lng}
                                    />
                                </GoogleMapReact>
                            </div>
                        </div>
                    </article>
                </div>
            }

            {details.employees &&
                <div className="c-distributor__team-content u-bg--wild-sand">
                    <div className="container">
                    <h2>{t("distributor.distributor.local-team")}</h2>
                        <div className="row">
                            {details.employees.map((employee, index) => (
                                <div className="col-sm-6 col-md-3" key={index}>
                                    <Employee employee={employee} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default withTranslation()(HeroDistributor);
